export default __webpack_public_path__ + "static/r-90-2-5f8f01bb1797fb43ae36b4582973f5c1.jpg";